import { QuestLog, QuestLogItem } from 'components/Docs/QuestLog';
import { IconSparkles } from '@posthog/icons';
import OSButton from 'components/OSButton';
import * as React from 'react';
export default {
  QuestLog,
  QuestLogItem,
  IconSparkles,
  OSButton,
  React
};